import {Util, UUID, UIUtil} from 'yougile-util'
interface ClickOutsideHandler {
  element: () => HTMLElement
  callback: (event: MouseEvent) => void
  exclude?: (target: Element) => boolean
}

export class ClickOutside {
  private static oneTimeHandlers: Map<UUID, ClickOutsideHandler> = new Map()

  public static once(handler: ClickOutsideHandler): UUID {
    const uuid = Util.UUID()
    this.oneTimeHandlers.set(uuid, {...{exclude: () => false}, ...handler})
    return uuid
  }

  public static cancel(uuid: UUID): void {
    this.oneTimeHandlers.delete(uuid)
  }

  public static triggerClick(event: MouseEvent): void {
    const notRunHandlers: Map<UUID, ClickOutsideHandler> = new Map()
    ClickOutside.oneTimeHandlers.forEach(
      (handler: ClickOutsideHandler, uuid: UUID) => {
        const {target} = event
        const el = handler.element()
        const moveToBody = document.querySelectorAll('.move-to-body')
        let isInMoveToBody = false
        if (moveToBody) {
          moveToBody.forEach(mtb => {
            if (mtb === target || UIUtil.isDescendant(mtb, target as Element)) {
              isInMoveToBody = true
            }
          })
        }
        if (
          isInMoveToBody ||
          el === target ||
          UIUtil.isDescendant(el, target as Element) ||
          handler.exclude(target as Element)
        ) {
          notRunHandlers.set(uuid, handler)
        } else {
          handler.callback(event)
        }
      }
    )
    ClickOutside.oneTimeHandlers = notRunHandlers
  }
}

document.addEventListener('mousedown', ClickOutside.triggerClick)
